<template>
  <dashboard>
    <template v-slot:content>
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5 class="mt-2" :class="[grn != '' ? 'text-success' :null]">
                      <img src="@/assets/images/big_tick.svg" width="20" v-if="grn != ''" />
                      {{Title}}
                    </h5>
                  </b-col>
                  <b-col lg="5" md="5">
                    <b-button
                      variant="dark"
                      class="float-right"
                      v-if="grn != ''"
                      @click="backAdvice"
                    >GRN List</b-button>
                    <b-row class="form-row grn-search" vertical-align="center" v-if="grn == ''">
                      <b-col md="9" class="pr-0">
                        <b-input-group size="md" class="box-shadow">
                          <b-input-group-text slot="prepend">
                            <font-awesome-icon :icon="['fas', 'search']" />
                          </b-input-group-text>
                          <b-form-input
                            v-model="search"
                            class="search"
                            placeholder="Enter barcode or search products"
                            v-on:keyup.enter="getItem"
                            ref="searchBox"
                            autocomplete="off"
                            v-shortkey.focus="['ctrl','s']"
                            autofocus
                          ></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col cols="3" md="3">
                        <b-button
                          variant="secondary"
                          class="w-100"
                          :disabled="disableCreateGrn"
                          @click="createGrn"
                        >
                          <span v-if="$loading == false">Create GRN</span>
                          <b-spinner small v-if="$loading == true"></b-spinner>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>
      <section class="fadein">
        <b-container fluid>
          <div class="customer-info table-dark-bg box-shadow mt-2 mb-3 p-4">
            <b-form v-on:submit.prevent>
              <b-row v-if="grn == ''">
                <b-col lg="3" class="text-left">
                  <label for class="mb-0">*Supplier</label>
                  <b-input
                    placeholder="Enter Supplier Name"
                    type="text"
                    autocomplete="off"
                    v-model="supplier"
                  ></b-input>
                </b-col>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0">*Place of Origin</label>
                  <b-input
                    placeholder="Enter place of origin"
                    autocomplete="off"
                    type="text"
                    v-model="place"
                  ></b-input>
                </b-col>
                <b-col lg="6" class="text-left">
                  <label for class="mb-0">GRN Remarks</label>
                  <b-input
                    type="text"
                    placeholder="Add Remark...."
                    autocomplete="off"
                    v-model="remark"
                  ></b-input>
                </b-col>
                <b-modal
                  ref="remark-modal"
                  size="md"
                  class="modal"
                  hide-footer
                  centered
                  title="Add Remarks"
                >
                  <b-form-textarea
                    id="textarea"
                    v-model="remarks.value"
                    placeholder="Enter Remarks..."
                    rows="4"
                    no-resize
                  ></b-form-textarea>
                  <div class="text-right">
                    <b-button
                      class="mt-3 btn-theme grey-btn"
                      variant="success"
                      type="submit"
                      @click="saveRemarks"
                    >Save</b-button>
                  </div>
                </b-modal>

                <b-modal
                  ref="quantity-modal"
                  title="Product Name & Description"
                  centered
                  size="lg"
                  class="pb-0"
                  no-close-on-esc
                  modal-class="quantity-modal"
                  no-close-on-backdrop
                  hide-footer
                  header-class="qty-header"
                >
                  <template slot="modal-header">
                    <b-container>
                      <b-row>
                        <b-col class="p-0">
                          <h3
                            class="modal-title"
                          >{{ modalData.product_name }} & {{ modalData.product_desc }}</h3>
                        </b-col>
                        <b-col class="p-0">
                          <b-button
                            variant="success"
                            class="float-right"
                            :disabled="updateBtnQty"
                            @click="updateQty(modalData.barcode)"
                          >Update Quantity</b-button>
                          <b-button
                            style="margin-right:10px;"
                            variant="danger"
                            class="float-right"
                            @click="closeQtyModal"
                          >Close</b-button>
                        </b-col>
                      </b-row>
                    </b-container>
                  </template>
                  <b-row>
                    <b-col>
                      <label for>Ordered Quantity</label>
                      <b-input type="number" disabled v-model="total_qty"></b-input>
                    </b-col>
                    <b-col>
                      <label for>Received Quantity</label>
                      <b-input
                        placeholder="0"
                        type="number"
                        v-model="received_qty"
                        :readonly="modalData.tracking != ''"
                        @click="received_qty = ''"
                      ></b-input>
                    </b-col>
                    <b-col>
                      <label for>Damaged Quantity</label>
                      <b-input
                        placeholder="0"
                        type="number"
                        v-model="damage_qty"
                        :readonly="modalData.tracking != ''"
                        @click="damage_qty = ''"
                      ></b-input>
                    </b-col>
                  </b-row>

                  <div v-if="modalData.tracking != ''">
                    <hr />
                    <div class="pt-1 pb-3 text-right justify-content-end">
                      <!-- <b-button size="sm" variant="light" class="ml-3" @click=" ">Add Quantity</b-button> -->
                      <b-button
                        size="sm"
                        class="btn-theme ml-3"
                        @click="addRow('Batch')"
                        v-if="modalData.tracking == 'Batch' || modalData.tracking == 'Batch/Serial'"
                      >Add Batch</b-button>
                      <b-button
                        size="sm"
                        class="btn-theme ml-3 mr-0"
                        @click="addRow('Serial')"
                        v-if="modalData.tracking == 'Serial' || modalData.tracking == 'Batch/Serial'"
                      >Add Serial</b-button>
                    </div>

                    <div>
                      <div class="padding-less-table">
                        <table class="table cart-table mt-3 table-dark">
                          <thead>
                            <tr class="sticky-top">
                              <th>#</th>
                              <th>Batch/Serial</th>
                              <th>Received Qty</th>
                              <th>Damaged Qty</th>
                              <th width="30"></th>
                            </tr>
                          </thead>
                          <tbody v-if="list != ''" class="grn-popup">
                            <tr v-for="(item, index) in list" :key="index">
                              <td v-text="index+1"></td>
                              <td>
                                <b-row>
                                  <b-col md="3">
                                    <label v-text="item.type"></label>
                                  </b-col>
                                  <b-col>
                                    <b-input
                                      placeholder="Batch Number"
                                      type="text"
                                      v-model="item.number"
                                    ></b-input>
                                  </b-col>
                                </b-row>
                              </td>
                              <td>
                                <b-input
                                  placeholder="0"
                                  type="number"
                                  v-model="item.received"
                                  @input="changeQty()"
                                ></b-input>
                              </td>
                              <td>
                                <b-input
                                  placeholder="0"
                                  type="number"
                                  v-model="item.damaged"
                                  @input="changeQty()"
                                ></b-input>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  class="btn btn-danger"
                                  @click="removeRow(index)"
                                >X</button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        class="d-flex align-items-center text-center d-none update-qty"
                        style="height:100%"
                        v-if="list == ''"
                      >
                        <h6
                          class="fw-normal w-100"
                          style
                        >Click on Add Serial / Add Batch to start adding quantities.</h6>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </b-row>

              <b-row v-if="grn != ''" class="mb-20">
                <b-col md="2">
                  <label for>GRN Number</label>
                  <p>{{ grn.grn_no }}</p>
                </b-col>
                <b-col md="2">
                  <label for>Date</label>
                  <p>{{ grn.date }}</p>
                </b-col>
                <b-col md="2">
                  <label>Received Quantity</label>
                  <p>{{ grn.received_qty }}</p>
                </b-col>
                <b-col md="2">
                  <label>Damaged Quantity</label>
                  <p>{{ grn.damage_qty }}</p>
                </b-col>
                <b-col md="2">
                  <!-- <label>Lost Quantity</label> -->
                  <!-- <p>{{ grn.lost_qty }}</p> -->
                </b-col>
              </b-row>
              <b-row v-if="grn != ''">
                <b-col md="2">
                  <label>Supplier</label>
                  <p>{{ grn.supplier }}</p>
                </b-col>
                <b-col md="2">
                  <label>Place of Origin</label>
                  <p>{{ grn.place_from }}</p>
                </b-col>
                <b-col md="8" v-if="grn.remarks != ''">
                  <label>Bill Remarks</label>
                  <p>{{ grn.remarks }}</p>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div class="table-dark-bg box-shadow cart-table-wrapper wow fadeIn grn">
            <table class="table cart-table mt-0 table-dark">
              <thead>
                <tr>
                  <th class="text-center pr-2">#</th>
                  <th width="20%" class="text-left">Product(s)</th>
                  <th class="text-center">Inventory Track</th>
                  <th class="text-center">Total Qty.</th>
                  <!-- <th class="text-center" v-if="advice.status == 'PARTIAL'">Remaining Qty</th> -->
                  <th class="text-center">Received Qty.</th>
                  <th class="text-center">Damaged Qty.</th>
                  <!-- <th class="text-center">Short/Excess</th> -->
                  <th class="text-center">Remarks</th>
                  <!-- <th class="text-center" v-if="grn == ''">Status</th> -->
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in GRNitems" :key="index">
                  <td class="text-center pr-2" v-text="index+1"></td>
                  <td style="padding-left: 0px !important;">
                    <p class="mb-0">
                      {{ item.product_name }}
                      <br />
                      {{ item.barcode }}
                    </p>
                  </td>
                  <td class="text-center">
                    <p class="mb-0" v-if="item.tracking.length > 1">{{item.tracking}}</p>
                    <p class="mb-0" v-else></p>
                  </td>
                  <td class="text-center" v-text="item.ordered"></td>
                  <!-- <td class="text-center" v-if="advice.status == 'PARTIAL'">{{ item.remaining }}</td> -->
                  <td class="text-center" v-text="item.received"></td>
                  <td class="text-center" v-text="item.damaged"></td>
                  <!-- <td class="text-center" v-text="item.lost"></td> -->
                  <td class="text-center">
                    <a
                      href="javascript:void(0)"
                      @click="openRemarks(item)"
                      class="w-100 text-muted"
                      v-if="item.remarks == '' && grn == ''"
                    >
                      <font-awesome-icon :icon="['fas', 'plus']" />&nbsp; Add Remarks
                    </a>
                    <div v-else>
                      <b-button
                        v-b-tooltip.hover
                        :title="item.remarks"
                        @click="openRemarks(item)"
                        variant="outline-secondary"
                        v-if="item.remarks != '' && grn == ''"
                      >Edit</b-button>
                      <h6 style="font-weight: normal;" v-if="grn != ''" v-text="item.remarks"></h6>
                    </div>
                  </td>
                  <!-- <td class="text-center" v-if="grn == ''">
                    <label class="text-success" v-if="item.status == 'Surplus'">Surplus</label>
                    <label class="text-danger" v-if="item.status == 'Deficit'">Deficit</label>
                  </td>-->
                  <td class="float-right mr-2">
                    <b-button
                      @click="openQty(item)"
                      variant="secondary"
                      class="grey-btn"
                      v-if="grn == ''"
                    >Update Qty</b-button>
                    <b-button
                      variant="secondary"
                      v-if="grn != ''"
                      :disabled="item.tracking.length == 0"
                    >Details</b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Dashboard from "../views/Dashboard";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";
import { totalmem } from "os";

//import { mapState } from 'vuex'
library.add(faQuestionCircle);

export default {
  mixins: [validationMixin],
  name: "add-hoc-grn",
  props: ["id"],
  components: {
    Dashboard,
  },
  mounted() {
    this.$refs["searchBox"].focus();
  },

  data() {
    return {
      Title: "New Ad-Hoc GRN",
      selected: null,
      searchableName: true,
      isBusy: false,
      remarks: {
        barcode: "",
        value: "",
      },
      GRNList: [],
      grn: "",
      search: "",
      place: "",
      supplier: "",
      modalData: [],
      received_qty: 0,
      damage_qty: 0,
      total_qty: 0,
      list: [],
      remark: "",
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
      customerData() {
        return this.$store.getters["sessions/getCustomerParam"];
      },
      disableCreateGrn() {
        // if (this.$loading == false) {
        //   return false;
        // }
        if (this.supplier != "" && this.place != "" && this.GRNList != "") {
          return false;
        } else {
          return true;
        }
      },
    }),
    GRNitems() {
      let data = [];
      let result = "";
      let self = this;
      this.GRNList.map(function (item, index) {
        if (self.grn != "") {
          data.push({
            id: index + 1,
            product_name: item.name,
            ordered: item.order_qty,
            barcode: item.barcode,
            received: item.received_qty,
            lost: item.lost_qty,
            damaged: item.damage_qty,
            remarks: item.remarks,
            tracking: item.status,
            status: item.temp_status,
            OK: "",
            batch: item.batch,
            serial: item.serial,
          });
        } else {
          data.push({
            id: index + 1,
            product_name: item.item_name,
            barcode: item.barcode,
            received: item.received,
            ordered: item.ordered,
            lost: item.lost,
            damaged: item.damaged,
            remarks: item.remarks,
            tracking: item.tracking,
            status: item.status,
            OK: "",
            batch: item.batch,
            serial: item.serial,
          });
        }
      });

      // result = data;
      return data;

      // if (!this.search) {
      //   return result;
      // }

      // const filterValue = this.search.toLowerCase();

      // const filter = event =>
      //   event.product_name.toLowerCase().includes(filterValue) ||
      //   //   event.product_desc.toLowerCase().includes(filterValue) ||
      //   event.barcode.toLowerCase().includes(filterValue);

      // return result.filter(filter);
    },
    updateBtnQty() {
      let isDisabled = true;
      if (this.list.length > 0) {
        console.log("Cool");
        if (this.received_qty > 0 || this.damage_qty > 0) {
          isDisabled = false;
        } else {
          isDisabled = true;
        }
        this.list.map((item) => {
          if (item.number == "" || item.number == 0) {
            isDisabled = true;
          }
        });
      } else {
        console.log("Not Cool");
        if (this.received_qty > 0 || this.damage_qty > 0) {
          isDisabled = false;
        } else {
          isDisabled = true;
        }
      }
      return isDisabled;
    },
  },
  methods: {
    contentShow(content) {
      this.isContentShow = content;
    },
    openRemarks(data) {
      this.remarks.barcode = data.barcode;
      this.remarks.value = data.remarks;
      this.$refs["remark-modal"].show();
    },
    closeRemarks(index) {
      this.$refs["remarks"].hide();
    },
    saveRemarks() {
      this.GRNList.filter((item) => {
        if (item.barcode == this.remarks.barcode) {
          item.remarks = this.remarks.value;
        }
      });
      this.$refs["remark-modal"].hide();
      this.remarks.value = "";
      this.remarks.barcode = "";
    },
    getItem: function () {
      this.$loading = true;
      let data = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        barcode: this.search,
        url: "/vendor/item-detail",
      };
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "fail") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          } else if (res.data.status == "success") {
            this.grnProducListing(res.data.item_detail);
          }
          this.$loading = false;
          this.search = "";
        })
        .catch((err) => {
          let alertData = {
            message: "No item found",
            type: "danger",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
          this.$loading = false;
          this.search = "";
        });
    },
    manuplateItem(data) {
      let status = "";
      if (data.has_batch == 1 && data.has_serial == 1) {
        status = "Batch/Serial";
      } else if (data.has_batch == 1) {
        status = "Batch";
      } else if (data.has_serial == 1) {
        status = "Serial";
      }
      let itemData = {
        received: 0,
        lost: 0,
        damaged: 0,
        remarks: "",
        tracking: status,
        status: "",
        batch: [],
        serial: [],
        product_name: data.item_name,
        ordered: 0,
      };
      let mergeData = Object.assign(itemData, data);
      return mergeData;
    },
    grnProducListing(data) {
      let existsItem = this.GRNList.filter((item) => {
        return item.barcode == data.barcode;
      });

      if (existsItem.length === 0) {
        let item = this.manuplateItem(data);
        this.GRNList.push(item);
      }

      if (this.GRNList.length > 0) {
        this.GRNList.filter((item) => {
          // console.log(item);
          let count = 0;
          let TotalQty = 0;
          if (data.barcode == item.barcode && item.tracking == "") {
            item.received = item.received + 1;
          } else if (item.tracking != "" && data.barcode == item.barcode) {
            this.openQty(item);
          }
          TotalQty = item.received + item.damaged;
          item.ordered = TotalQty;
          return item;
        });
      }
    },
    openQty(data) {
      let self = this;
      this.$refs["quantity-modal"].show();
      this.modalData = data;
      this.received_qty = data.received;
      this.damage_qty = data.damaged;
      this.total_qty = data.ordered;
      if (data.batch.length > 0) {
        data.batch.map((batch) => {
          self.list.push({
            type: "Batch",
            number: batch.batch_no,
            received: batch.received_qty,
            damaged: batch.damaged_qty,
          });
        });
      }
      if (data.serial.length > 0) {
        data.serial.map((serial) => {
          self.list.push({
            type: "Serial",
            number: serial.serial_no,
            received: serial.received_qty,
            damaged: serial.damaged_qty,
          });
        });
      }
    },
    closeQtyModal() {
      this.$refs["quantity-modal"].hide();
      this.modalData = [];
      this.list = [];
      this.received_qty = 0;
      this.damage_qty = 0;
    },
    getValue(value) {
      this.search = value;
    },
    addRow(type) {
      this.list.push({
        type: type,
        number: "",
        received: "",
        damaged: "",
      });
    },
    removeRow(index) {
      this.list.splice(index, 1);
      this.changeQty();
    },
    changeQty() {
      let received = 0;
      let damaged = 0;
      let total_qty = 0;
      this.list.map((item) => {
        if (item.received == "") {
          item.received = 0;
        }
        if (item.damaged == "") {
          item.damaged = 0;
        }
        received += parseInt(item.received);
        damaged += parseInt(item.damaged);
        total_qty += received + damaged;
        // item.lost_qty = 0;
        // }
      });
      console.log("Received :- " + received);
      console.log("Damaged :- " + damaged);
      console.log("Total Qty :- " + total_qty);
      this.received_qty = received;
      this.damage_qty = damaged;
      this.total_qty = total_qty;
    },
    updateQty(data) {
      this.GRNList.filter((item) => {
        if (item.barcode == data) {
          let totalQty =
            parseInt(this.received_qty) + parseInt(this.damage_qty);

          // let totalOrder = item.order_qty;
          // console.log("Total Order: - " + totalOrder);
          // console.log("Total Qty: - " + totalQty);
          //   console.log("Lost: - " + totalQty);
          // if (totalQty == totalOrder) {
          //   item.temp_status = "";
          //   // item.lost_qty = 0;
          // } else if (totalQty > totalOrder) {
          //   item.lost_qty = totalQty - totalOrder;
          //   item.temp_status = "Surplus";
          // } else if (totalQty < totalOrder) {
          //   item.lost_qty = -Math.abs(totalQty - totalOrder);
          //   item.temp_status = "Deficit";
          // }

          item.received = this.received_qty;
          item.damaged = this.damage_qty;
          item.ordered = this.total_qty;
          if (this.list.length > 0) {
            // console.log(item.batch);
            item.batch = [];
            this.list.map((num) => {
              item.batch.push({
                batch_no: num.number,
                exp_date: "",
                mfg_date: "",
                received_qty: num.received,
                damaged_qty: num.damaged,
                valid_months: "",
              });
            });
          }
        }
        return item;
      });
      this.$refs["quantity-modal"].hide();
      this.received_qty = 0;
      this.damage_qty = 0;
      this.total_qty = 0;
      this.list = [];
      this.modalData = [];
    },
    createGrn() {
      let self = this;
      let data = [];
      let totalRequestQty = 0;
      let totalGetQty = 0;
      this.GRNList.map((item) => {
        // totalGetQty +=
        //   parseInt(item.received_qty) +
        //   parseInt(item.damage_qty) +
        //   parseInt(item.lost_qty);
        if (item.received > 0 || item.damaged > 0 || item.lost_qty) {
          data.push({
            barcode: item.barcode,
            advice_list_id: 0,
            received_qty: item.received,
            damage_qty: item.damaged,
            lost_qty: 0,
            remarks: item.remarks,
            batch: item.batch,
            serial: item.serial,
          });
        }
      });
      if (data.length > 0) {
        self.createGrnAPICall(data);
      } else {
        let errorData = {
          msg: msg.CREATE_GRN,
          btntext: "Continue",
          status: "customer_not_tag",
        };
        this.$store.commit("showMessage", errorData);
      }
    },
    createGrnAPICall(data) {
      this.$loading = true;
      if (this.supplier == "") {
        let alertData = {
          message: "Please enter supplier name",
          type: "danger",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      }
      if (this.place == "") {
        let alertData = {
          message: "Please enter place of origin",
          type: "danger",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      }
      let postData = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        remarks: this.remark,
        grn_list: JSON.stringify(data),
        supplier: this.supplier,
        place: this.place,
        terminal_id: this.state.system.settings.terminal_id,
        url: "/vendor/create-adhoc",
      };
      // console.log(postData);
      axios.post(postData.url, postData).then((res) => {
        if (res.data.status == "fail") {
          let alertData = {
            message: res.data.message,
            type: "danger",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
        } else if (res.data.status == "success") {
          this.GRNList = res.data.data.product_list;
          this.grn = res.data.data;
          this.Title = res.data.message;
        }
        this.$loading = false;
      });
    },
    backAdvice() {
      this.$router.push("/grn-list/");
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-select {
  font-size: 13px;
}
.customer-info .vdp-datepicker {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.pill {
  background: $body-color-light;
  border-radius: 5px;
  position: relative;
  &:before {
    width: 7px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
}

h4 {
  color: $mid-grey;
}
.pending.pill {
  &:before {
    background: $success-btn;
  }
}
.partial.pill {
  &:before {
    background: $dark-card-text;
  }
}
.complete.pill {
  &:before {
    background: $danger-btn;
  }
}
.customer-info input.form-control,
.b-table .filled {
  background: $body-color-light;
}
.b-table .danger-filled {
  background: $danger-btn;
  color: $white-color;
  &::placeholder {
    color: $white-color;
  }
  &:-ms-input-placeholder {
    color: $white-color;
  }
  &::-ms-input-placeholder {
    color: $white-color;
  }
}
.cart-table {
  .btn {
    padding: 0.375rem 2rem;
  }
  input {
    padding: 1.1rem 0.5rem;
  }
}
.modal-body {
  padding: 10px 0;
  .cart-table input {
    padding: 0.5rem 0.5rem;
    height: auto;
    width: inherit;
  }
  h6 {
    color: $mid-grey;
  }
}
.qty-header {
  h3 {
    font-size: 1.3rem;
  }
}
.padding-less-table {
  border: 0px solid red;
  height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
  label {
    font-size: 14px;
    margin-top: 8px;
    color: #3f8d8a;
  }
}
.grn th {
  text-align: center;
}
.grn-popup tr:hover {
  background-color: transparent !important;
}
.theme-light .grn-search .form-control:focus {
  background-color: #fff !important;
}
.theme-light textarea.form-control:focus {
  background-color: #fff !important;
  border-color: #ced4da;
}
p {
  color: #c0c0c0;
}
.padding-less-table .table {
  margin: 0px !important;
}
.grn-search .form-control {
  border: none !important ;
}
.update-qty h6 {
  position: absolute;
  left: 0%;
  top: 300px;
}
</style>
